export default "__VITE_ASSET__IHOrLA9t__"